<template>
  <div v-if="pay_flag != 1" class="index">
    <div class="vh">
      <Header2 :companyInfo="comnpany_info"/>
      <div class="cut-off">年报正常申报6月30日前截止</div>
      <div id="details" class="details common">
        <div class="title">
          <span class="leftBack"></span>
          <span class="leftBack2"></span>
          <span class="text">逾期未报有最高罚款1万元风险</span>
          <span class="rightBack2"></span>
          <span class="rightBack"></span>
        </div>
        <div class="xize">
          <div class="title111">
            <div class="top">《市场主体登记管理条例实施细则》</div>
            <div class="bottom">根据第十一章第七十条规定</div>
          </div>
          <div class="content111">
            <span>市场主体未按照法律、行政法规规定的期限公示或者报送年度报告的，</span>
            <span>由登记机关列入经营异常名录，可以处1万元以下罚款。</span>
          </div>
        </div>
        <!-- <div class="qishi">
          <span class="gang"></span>
          <div>
            <span>每年申报起止时间：</span>
            <span>1月1日-6月30日</span>
          </div>
          <span class="gang"></span>
        </div> -->
        <div class="box10">
          <!-- <div class="applicationStatus">
            <span>当前年报申报情况</span>
            <span>（信息来源于国家企业信用信息公示系统）</span>
          </div>
          <div class="remind1">
            <img src="../assets/images/bell.png" alt="" />
            <span>提醒:</span>
            <span>您当前共计</span>
            <span>{{ not }}个年度报告未及时申报</span>
          </div> -->
          <!-- <div class="remind2">（信息来源于国家企业信用信息公示系统,更新可能会有延迟）</div> -->
          <!-- <div class="table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>对应年度</th>
                  <th>是否申报</th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="index < more" v-for="(item, key, index) in comnpany_shen" :key="key">
                  <td>{{ index + 1 }}</td>
                  <td>{{ key.slice(0, -1) + "的年度报告" }}</td>
                  <td :style="[{ color: item == 1 ? '#116bff' : '#df1a1a' }]">
                    {{ item == 1 ? "已申报" : key.slice(0, -1) == 2023 ? "暂未申报" : "逾期未报" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
          <!-- <div v-if="Object.keys(comnpany_shen).length > 5 && more == 5" @click="showMore(more)" class="prompt">
            <img src="../assets/images/pulldown.png" alt="" />
            <div>点击查看全部年度</div>
          </div>
          <div v-if="Object.keys(comnpany_shen).length > 5 && more != 5" @click="showMore(more)" class="prompt">
            <img style="transform: rotate(180deg)" src="../assets/images/pulldown.png" alt="" />
            <div>点击收起全部年度</div>
          </div> -->
          <div v-observe-visibility="visibilityChanged" class="btn" @click="skip">
            <!-- <div>（如您需要代办服务请点击“立即申报”）</div> -->
            <div>立即申报</div>
          </div>
        </div>
      </div>
      <div class="remind common">
        <span>特别提醒：</span>
        <span
        >河北鲸诚信用服务有限公司为经营主体提供代办服务，收取服务代办费用，如果代办不成功，我们承诺全额退款。我们非国家工商行政管理部门，仅为提高经营主体办理效率，经营主体也可通过线下所属市场监督管理部门或线上国家企业信息信息公示系统免费办理，请知悉!</span
        >
      </div>
    </div>
    <!-- <div class="consult common">
      <div class="title">
        <span class="leftBack"></span>
        <img src="../assets/images/longtime.png" alt="" />
      </div>
      <div class="button">
        <img src="../assets/images/counselling.png" alt="" />
        <div @click="showkefu">
          点击咨询注销
          <img src="../assets/images/finger.png" alt="" />
        </div>
      </div>
      <div class="text10">
        <img src="../assets/images/laba.png" alt="" />
        <div>
          <span>先注销</span>
          <span>后收费</span>
          <span>不成功</span>
          <span>不收费</span>
        </div>
      </div>
    </div> -->
    <div class="consequences common">
      <div class="title">
        <span class="leftBack"></span>
        <span class="leftBack2"></span>
        <span class="text">逾期未报送年报的后果</span>
        <span class="rightBack2"></span>
        <span class="rightBack"></span>
      </div>
      <div class="terms">
        <div class="detailed">
          <div class="directory">
            <img alt="" src="../assets/images/jinggao.png"/>
            <div class="yellowBack">
              <div>《市场主体登记管理条例实施细则》</div>
              <div>根据第十一章第七十条规定:</div>
            </div>
          </div>
          <div class="content">
            2022年3月1日，国家市场监督管理总局令第52号公布《中华人民共和国市场主体登记管理条例实施细则》，根据第十一章第七十条规定，市场主体未按照法律、行政法规规定的期限公示或者报送年度报告的，<span
          >由登记机关列入经营异常名录，可以处1万元以下的罚款。</span
          >
          </div>
        </div>
        <div class="detailed">
          <div class="directory">
            <img alt="" src="../assets/images/jinggao.png"/>
            <div class="yellowBack">
              <div>多部门联合<span>信用惩戒</span></div>
            </div>
          </div>
          <div class="content">
            被列入经营异常名录或标注经营异常状态的市场主体将会受到多个部门联合信用惩戒，在政府采购、招投标、获得荣誉、取到多个部门联合信用惩戒，得政府资金支持等方面<span
          >将被依法予以限制或者禁入。</span
          >
          </div>
        </div>
        <div class="icon">
          <div v-for="(item, index) in iconList" :key="index">
            <img :src="item.imgUrl" alt=""/>
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="terms">
        <div class="text222">
          <div>1、企业被列入“经营异常名录”的信息将同步向全社会公示；</div>
          <div>2、影响企业商誉及对外形象;</div>
          <div>3、影响公司法定代表人及董监高等人员个人信誉及形象；</div>
          <div>4、企业在政府采购、工程招投标、国有土地出让、授予荣誉称号等事项上,将被予以限制或者禁入；</div>
          <div>
            5、被列入经营异常名录的企业,满3年仍未履行公示义务的,将被列入严重违法企业名单,并通过企业信用信息公示系统向社会公示；
          </div>
          <div>6、被列入严重违法企业名单的企业的法定代表人、负责人，3年内不得担任其他企业的法定代表人、负责人；</div>
        </div> -->
      <!-- <div class="detailed">
          <div class="directory">
            <img src="../assets/images/jinggao.png" alt="" />
            <div class="yellowBack">
              <div>《市场主体登记管理条例实施细则》</div>
              <div>根据第十一章第七十条规定:</div>
            </div>
          </div>
          <div class="content">
            2022年3月1日，国家市场监督管理总局令第52号公布《中华人民共和国市场主体登记管理条例实施细则》，根据第十一章第七十条规定，市场主体未按照法律、行政法规规定的期限公示或者报送年度报告的，<span
              >由登记机关列入经营异常名录，可以处1万元以下的罚款。</span
            >
          </div>
        </div>
        <div class="detailed">
          <div class="directory">
            <img src="../assets/images/jinggao.png" alt="" />
            <div class="yellowBack">
              <div>多部门联合<span>信用惩戒</span></div>
            </div>
          </div>
          <div class="content">
            被列入经营异常名录或标注经营异常状态的市场主体将会受到多个部门联合信用惩戒，在政府采购、招投标、获得荣誉、取到多个部门联合信用惩戒，得政府资金支持等方面<span
              >将被依法予以限制或者禁入。</span
            >
          </div>
        </div>
        <div class="icon">
          <div v-for="(item, index) in iconList" :key="index">
            <img :src="item.imgUrl" alt="" />
            <span>{{ item.text }}</span>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <!-- <div class="way common">
      <div class="title">
        <span class="leftBack"></span>
        <span class="text">企业年报报送方式</span>
        <span class="rightBack"></span>
      </div>
      <div class="methods">
        <div>
          <span>专业机构代申报年报——专业 高效 快捷</span>
          <img src="../assets/images/tab.png" alt="" />
        </div>
        <div>企业信用信息公示系统自行申报 费时费力 流程复杂</div>
      </div>
    </div> -->
    <!-- <contact>
      <div>申报咨询</div>
    </contact> -->
    <Footer/>
    <div v-show="show" class="floatBtn">
      <div class="btn" @click="skip">立即申报</div>
      <div>（如您需要代办服务请点击“立即申报”）</div>
    </div>
    <kefu ref="kefu"/>
  </div>
</template>
<script>
import Header2 from "../components/header2";
import footer from "../components/footer.vue";
import contact from "../components/contact.vue";
import kefu from "../components/kefu.vue";
import {get_company} from "../api/request";
import {MessageBox} from "mint-ui";

export default {
  name: "", //
  data() {
    return {
      random: "1vQ22", //随机字符串
      comnpany_info: "", //公司信息
      comnpany_shen: {}, //申报情况列表
      iconList: [
        {imgUrl: require("../assets/images/icon1.png"), text: "列入经营异常"},
        {imgUrl: require("../assets/images/icon2.png"), text: "采购、招标受阻"},
        {imgUrl: require("../assets/images/icon3.png"), text: "工商行政处罚"},
        {imgUrl: require("../assets/images/icon4.png"), text: "新注册企业受阻"},
        {imgUrl: require("../assets/images/icon5.png"), text: "满三年列入黑名单"},
        {imgUrl: require("../assets/images/icon6.png"), text: "信用贷款受阻"},
      ],
      date: new Date().getFullYear(), //获取年份
      show: false, //底部按钮开关
      pay_flag: 1,
      not: 0,
      more: 5,
    };
  },
  components: {
    Footer: footer,
    contact,
    Header2,
    kefu,
  },
  props: {},
  methods: {
    showMore(more) {
      if (more == 5) {
        this.more = Object.keys(this.comnpany_shen).length;
        document.getElementById("creditCode").scrollIntoView();
      } else {
        this.more = 5;
      }
    },
    showkefu() {
      this.$refs.kefu.show = true;
    },
    //底部按钮是否显示 中间按钮可见时隐藏 vue插件
    visibilityChanged(isVisible) {
      if (isVisible) {
        // 元素变得可见
        this.show = false;
        let index = document.getElementsByClassName("index")[0];
        index.style.paddingBottom = "0px";
      } else {
        // 元素变得不可见
        this.show = true;
        let index = document.getElementsByClassName("index")[0];
        index.style.paddingBottom = "2.4rem";
      }
    },
    //判断是否为微信内置浏览器
    isWeiXin() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    },
    //跳转
    skip() {
      this.$router.push({
        path: "/fillIn",
        query: {random: this.random, id: this.comnpany_info.id, comnpany_info: JSON.stringify(this.comnpany_info)},
      });
    },
    //截取连接中的随机字符串
    getRandom() {
      localStorage.setItem("nbnbRandom", this.random);
      // let href = this.$route.path;
      // if (href === "/") {
      //   this.dialog();
      // } else {
      //   this.random = href.split("/").pop();
      //   localStorage.setItem("nbnbRandom", this.random);
      // }
    },
    //没有随机字符串时弹窗
    dialog() {
      MessageBox({
        title: "提示",
        message:
            "<div><div>非法访问，请联系客服获取链接地址</div><div>客服电话：<span style='color:#e44f52'>400-056-5663</span></div></div>",
        showConfirmButton: false,
        showCancelButton: false,
        closeOnClickModal: false,
      });
    },
    //获取公司信息
    get_company() {
      get_company({
        type: 1,
        random: this.random,
      }).then((res) => {
        this.comnpany_info = res.data.comnpany_info;
        localStorage.setItem("nbnbcomnpany_info", JSON.stringify(res.data.comnpany_info));
        this.comnpany_shen = res.data.comnpany_shen;
        this.not = Object.values(this.comnpany_shen).filter((value) => value == 2).length;
        this.comnpany_shen = this.sortObj(this.comnpany_shen);
        this.pay_flag = res.data.pay_flag;
        if (res.data.pay_flag == 1) {
          this.$router.push({path: "/orders"});
        }
      });
    },
    sortObj(obj) {
      var arr = [];
      for (var i in obj) {
        arr.push([obj[i], i]);
      }
      arr.reverse();
      var len = arr.length;
      var obj = {};
      for (var i = 0; i < len; i++) {
        obj[arr[i][1] + "a"] = arr[i][0];
      }
      return obj;
    },
  },
  created() {
    this.getRandom();
    this.get_company();
  },
  destroyed() {
  },
};
</script>
<style lang="less" scoped>
/* by wdl */
.index {
  background: #ececec;

  .cut-off {
    font-size: 22px;
    color: #B10909;
    text-align: center;
    background: #FFE981;
    padding: 7px 0;
    width: 359px;
    margin: 9px auto;
    box-sizing: border-box;
    font-weight: bolder;
    letter-spacing: 2px;
  }

  .common {
    background: #fff;
    box-shadow: 0px 2px 5px 0px #a7d7fb;
    width: 359px;
    margin: 10px auto 0;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 10px 10px;
  }

  .details {
    padding: 4px 7px 16px;

    .xize {
      box-shadow: 0px 0px 5px 0px #606060;
      padding: 15px 14px 12px;
      margin-top: 23px;

      .title111 {
        background: #ffd71e;
        text-align: center;
        padding: 6px 0;
        font-weight: bolder;

        .top {
          font-size: 18px;
        }

        .bottom {
          font-size: 14px;
          margin-top: 9px;
        }
      }

      .content111 {
        font-size: 14px;
        text-align: justify;
        margin-top: 24px;
        width: calc(100% + 12px);
        margin-left: -7px;
        line-height: 24px;
        letter-spacing: 1px;

        span:nth-of-type(2) {
          color: #e42a04;
          font-weight: bolder;
          text-decoration: underline;
        }
      }
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% + 14px);
      margin-left: -7px;
      letter-spacing: 1px;

      .rightBack,
      .leftBack {
        display: inline-block;
        width: 20px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }

      .leftBack2,
      .rightBack2 {
        display: inline-block;
        width: 5px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }

      .leftBack,
      .rightBack2 {
        margin-right: 4px;
      }

      .text {
        font-size: 22px;
        color: #df1a1a;
        font-weight: bolder;
        white-space: nowrap;
        margin: 0 5px;
        // font-family:Bold;
      }
    }

    .box10 {
      // padding: 12px 10px;
      // box-shadow: 0px 0px 5px 0px #606060;
      // border-radius: 5px;
      // margin-top: 23px;
    }

    .qishi {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      margin-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #d3d3d3;

      .gang {
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #df1a1a;
        flex: 1;
      }

      div {
        margin: 0 10px;

        span:nth-of-type(1) {
          font-weight: bolder;
        }
      }
    }

    .prompt {
      text-align: center;
      font-size: 9px;

      img {
        display: block;
        width: 20px;
        height: 15px;
        margin: 12px auto 8px;
      }
    }

    .applicationStatus {
      display: flex;
      align-items: center;
      justify-content: center;

      span:nth-of-type(1) {
        font-size: 16.5px;
        font-weight: bolder;
      }

      span:nth-of-type(2) {
        font-size: 10px;
      }
    }

    .remind1 {
      display: flex;
      align-items: center;
      font-size: 14.5px;
      margin-top: 20px;
      letter-spacing: 1px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      span:nth-of-type(1) {
        font-weight: bold;
      }

      span:nth-of-type(3) {
        font-weight: bolder;
        color: #df1a1a;
        border-bottom: 2px solid #df1a1a;
        font-family: 思源黑体 Bold;
        font-size: 16px;
      }
    }

    .remind2 {
      text-align: center;
      font-size: 11px;
      margin-top: 15px;
    }

    .table {
      margin-top: 15px;
      text-align: center;
      background: #ffd855;
      padding: 2px;

      table {
        width: 100%;

        td {
          background: #fff;
          padding: 6px 0;
        }

        td:nth-last-child(1) {
          color: #df1a1a;
        }
      }
    }

    .btn {
      width: 302px;
      height: 48px;
      font-weight: bold;
      font-size: 26px;
      color: #ffffff;
      text-align: center;
      margin: 23px auto 0;
      letter-spacing: 4px;
      background: #116bff;
      border-radius: 8px;
      line-height: 48px;
    }
  }

  .remind {
    text-align: justify;
    line-height: 15px;
    box-sizing: border-box;


    span:nth-of-type(1) {
      font-size: 10px;
      letter-spacing: 1px;
      color: #606060;
    }

    span:nth-of-type(2) {
      color: #959292;
      font-size: 9px;
      letter-spacing: 1px;
    }
  }

  .way {
    margin-bottom: 10px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% + 20px);
      margin-left: -10px;
      letter-spacing: 4px;

      .rightBack,
      .leftBack {
        display: block;
        width: 75px;
        height: 21.5px;
        background: url(../assets/images/way.png);
        background-size: 100% 100%;
      }

      .text {
        font-size: 20px;
        color: #df1a1a;
        font-weight: bolder;
        white-space: nowrap;
        margin: 0 5px;
      }

      .leftBack {
        transform: rotate(180deg);
      }
    }

    .methods {
      div {
        padding: 10px 5px;
        font-size: 14px;
        font-weight: bold;
        margin-top: 12px;
      }

      div:nth-of-type(1) {
        border: 1px solid #df1a1a;
        color: #df1a1a;
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 14px;
          margin-left: 5px;
        }
      }

      div:nth-of-type(2) {
        border: 1px solid #6e6a6a;
        color: #6e6a6a;
      }
    }
  }

  .consult {
    padding: 10px;

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      font-weight: bold;
      letter-spacing: 2px;

      img {
        width: 294px;
        height: 31px;
      }

      .leftBack {
        display: inline-block;
        background: url("../assets/images/jinggao.png");
        background-size: 100% 100%;
        width: 28px;
        height: 28px;
        margin-right: 5px;
      }

      // .text {
      //   background: #ffd855;
      //   border-radius: 0 15px 15px 0;
      //   padding: 5px 15px 5px 10px;
      //   font-size: 18px;
      //   span {
      //     color: #df1a1a;
      //   }
      // }
    }

    .text10 {
      font-size: 13px;
      font-weight: bolder;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 2px;
      margin: 0 auto;

      img {
        width: 18px;
        height: 19px;
        margin-right: 4px;
      }

      div {
        padding: 2px 10px;
        border: 2px solid #df1a1a;
        border-radius: 5px;

        span:nth-of-type(1) {
          color: #116bff;
        }

        span:nth-of-type(2) {
          margin-right: 10px;
        }

        span:nth-of-type(3) {
          color: #df621a;
        }
      }
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 25px 0 21px;

      img {
        width: 24px;
        height: 26px;
        margin-right: 10px;
      }

      div {
        background: url("../assets/images/button.png");
        background-size: 100% 100%;
        width: 126px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        letter-spacing: 2px;
        font-weight: bolder;
        position: relative;

        img {
          width: 29px;
          height: 21px;
          position: absolute;
          right: -29px;
          bottom: -10px;
          animation: scale 0.5s infinite;
        }
      }
    }
  }

  .consequences {
    margin-bottom: 14px;
    padding-top: 4px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% + 20px);
      margin-left: -10px;
      letter-spacing: 4px;

      .rightBack,
      .leftBack {
        display: inline-block;
        width: 45px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }

      .leftBack2,
      .rightBack2 {
        display: inline-block;
        width: 5px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }

      .leftBack,
      .rightBack2 {
        margin-right: 4px;
      }

      .text {
        font-size: 22px;
        color: #e00404;
        font-weight: bolder;
        white-space: nowrap;
        margin: 0 16px;
        font-family: Bold;
      }
    }

    .terms {
      box-shadow: 0px 0px 5px 0px #606060;
      padding: 12px 10px;
      margin-top: 23px;

      .detailed {
        .directory {
          display: flex;
          align-items: center;

          span {
            color: #df1a1a;
          }

          img {
            width: 35px;
            height: 35px;
            margin-right: 5px;
          }

          .yellowBack {
            background: url(../assets/images/yellow.png);
            background-size: 100% 100%;
            padding: 0px 10px 0px 20px;
            height: 46px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: fit-content;
            font-weight: bold;

            div:nth-of-type(1) {
              font-size: 15px;
            }

            div:nth-of-type(2) {
              font-size: 13px;
              margin-top: 5px;
              margin-left: 7px;
            }
          }
        }

        .content {
          line-height: 20px;
          text-indent: 2em;
          margin-top: 15px;
          font-size: 12px;
          text-align: justify;
          padding: 0 5px;

          span {
            color: #df1a1a;
            font-weight: bolder;
          }
        }
      }

      .detailed:nth-of-type(2) {
        margin-top: 19px;
      }

      .icon {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 31%;
          padding: 10px 5px;
          box-sizing: border-box;
          box-shadow: 0px 0px 5px 2px #cadeff;
          margin-top: 20px;
          border-radius: 5px;

          img {
            width: 35px;
            height: 35px;
            margin-bottom: 5px;
          }

          span {
            font-size: 10px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .floatBtn {
    padding: 10px 10px;
    background: #fff;
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    bottom: 0;

    .btn {
      width: 302px;
      height: 48px;
      font-weight: bold;
      font-size: 26px;
      color: #ffffff;
      text-align: center;
      margin: 0px auto;
      letter-spacing: 4px;
      background: #116bff;
      border-radius: 8px;
      line-height: 48px;
      animation: scale 1.5s infinite;
    }

    div:nth-of-type(2) {
      font-size: 10px;
      text-align: center;
      margin-top: 5px;
    }
  }
}

@keyframes scale {
  /* from表示动画开始位置 也可以使⽤0%*/
  from {
    transform: scale(1);
  }

  /* to动画的结束位置 也可以使⽤100%*/
  to {
    transform: scale(1.05);
  }
}
</style>
